// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__24EKH","containerItemsCenter":"Skeleton_containerItemsCenter__1ceRp"};